<template>
  <BreadCrumb PageTitle="Nouveau Bon de livraison (STOCK)" />
  <AddNote />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import AddNote from "@/components/Notes/StockDelivery/AddNote.vue";

export default defineComponent({
  name: "AddNotePage",
  components: {
    BreadCrumb,
    AddNote,
  },
});
</script>